<script>
  import {mapState, mapMutations, mapActions} from 'vuex';
  import InteractiveSearchMultiSelect from '@/components/shared_components/form_fields/InteractiveSearchMultiSelect';

  export default {
    extends: InteractiveSearchMultiSelect,
    computed: {
      ...mapState('AllCustomersStore', {
        searchQuery: ({customerSearchQuery}) => customerSearchQuery
      })
    },
    methods: {
      ...mapActions({
        submitAction: 'AllCustomersStore/searchEnterCustomersByName',
        cancelSearch: 'AllCustomersStore/cancelSearchCustomers'
      }),
      ...mapMutations({
        setSearchQueryMutation: 'AllCustomersStore/setCustomerSearchQuery'
      })
    }
  };
</script>
